module.exports = __webpack_public_path__ + "img/black-bg.f8547fb5.png";